<template>
  <div v-show="isActive"
       role="tabpanel"
       :hidden="!isActive"
       :aria-labelledby="'tab-' + aliasSlug"
       :id="'tab-content-' + aliasSlug">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'tab',
    props: {
      name: {
        required: true
      },
      alias: {
        required: true
      },
      selected: {
        default: false
      }
    },
    data () {
      return {
        isActive: this.$route.hash === this.href,
        aliasSlug: this.alias.toLowerCase().replace(/ /g, '-')
      }
    },
    computed: {
      href () {
        return '#' + this.aliasSlug
      }
    },
    mounted () {
      this.isActive = this.$route.hash ? this.$route.hash === this.href : this.selected
    }
  }
</script>



// WEBPACK FOOTER //
// Tab.vue?20148d15